import H5 from '@base/H5/H5';
import Image from '@base/Image';
import P2 from '@base/P2/P2';
import styled from '@emotion/styled';
import { Spacings, Fonts } from '@styles/index';

const ContentWrapper = styled.div`
  height: 100vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 ${Spacings.SPACING_10B};
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 80px;
  width: 80px;
  margin-bottom: ${Spacings.SPACING_3B};
`;

const StyledH5 = styled(H5)`
  width: 90%;
  font-weight: ${Fonts.SEMIBOLD};
  text-align: center;
`;

const StyledP2 = styled(P2)`
  margin-top: ${Spacings.SPACING_1B};
  text-align: center;
`;

const GTPMobileBlocker = ({ goalInfo }) => {
  return (
    <ContentWrapper>
      <ImageWrapper>
        <Image src="/gtp/gtp-mobile-icon.svg" alt="educator" layout="fill" />
      </ImageWrapper>
      <StyledH5>Access {goalInfo.name} from your desktop</StyledH5>
      <StyledP2 color="var(--color-text-secondary)">
        We’re bringing this goal to the app soon. You can access it from desktop
        till then.
      </StyledP2>
    </ContentWrapper>
  );
};

export default GTPMobileBlocker;
